import React, { Component } from 'react';
import { matchPath } from 'react-router';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as GroupsActions } from 'store/ducks/groups';

import { Validate } from 'common';
import { Page, Breadcrumbs } from 'components';
import { Form } from 'pages/Configs/Groups/components';

class Edit extends Component {
  state = {
    data: {
      title: '',
      alias: '',
      description: '',
      group_roles_attributes: [],
      extra_data: {
        lock_ldap_store_place: false,
        lock_ldap_feed_local: false,
        lock_ldap_store_channel: false,
      },
    },

    errors: {},

    breadcrumbs: [
      { name: 'Home', to: '/' },
      { name: 'Configurações', to: '/configs' },
      { name: 'Grupos de Acesso', to: '/configs/groups' },
      { name: 'Detalhes', to: '' },
    ],
  };

  componentDidMount() {
    this.props.getGroupRequest(this.handleGetId());
  }

  componentDidUpdate(oldProps) {
    const { group } = this.props;

    if (oldProps.group.loading && !group.loading) {
      this.setState({
        data: {
          title: group.data.attributes.title,
          alias: group.data.attributes.alias,
          description: group.data.attributes.description,
          group_roles_attributes: group.data.attributes.roles.map(role => ({
            value: role.id,
            label: role.title,
          })),
          extra_data: {
            lock_ldap_store_place:
              group.data.attributes.extra_data && group.data.attributes.extra_data.lock_ldap_store_place
                ? group.data.attributes.extra_data.lock_ldap_store_place
                : false,
            lock_ldap_feed_local:
              group.data.attributes.extra_data && group.data.attributes.extra_data.lock_ldap_feed_local
                ? group.data.attributes.extra_data.lock_ldap_feed_local
                : false,
            lock_ldap_store_channel:
              group.data.attributes.extra_data && group.data.attributes.extra_data.lock_ldap_store_channel
                ? group.data.attributes.extra_data.lock_ldap_store_channel
                : false,
          },
        },
      });
    }
  }

  handleGetId = () => {
    const match = matchPath(this.props.location.pathname, { path: '/configs/groups/:id/edit' });
    const { id } = match.params;

    return id;
  };

  handleValidate = () => {
    const { form } = this.state;

    const rules = {
      title: {
        required: true,
      },

      description: {
        required: true,
      },

      alias: {
        required: true,
      },
    };

    const validate = Validate(form, rules);
    this.setState({ errors: validate.errors });

    return validate.valid;
  };

  handleChange = data => {
    this.setState({ form: data });
  };

  handleSubmit = e => {
    e.preventDefault();
    if (!this.handleValidate()) return;

    const { form } = this.state;

    const group = {
      ...form,
      group_roles_attributes: form.group_roles_attributes.map(role => ({ auth_role_id: role.value })),
    };

    this.props.updateGroupRequest(this.handleGetId(), {
      group,
    });
  };

  render() {
    const { data, errors, breadcrumbs } = this.state;
    const { update } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Form
          data={data}
          saving={update.loading}
          errors={errors}
          onChange={this.handleChange}
          onSubmit={this.handleSubmit}
        />
      </Page>
    );
  }
}

const mapState = state => ({
  group: state.groups.detail,
  update: state.groups.update,
});

const mapActions = dispatch => bindActionCreators(GroupsActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(Edit);
